/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import { useSelector } from "react-redux";
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import CursoOpinionForm from './CursoOpinionForm';
import * as validations from '../../validations/validations';
import * as cursoopinionActions from '../../actions/cursoopinionActions';
import * as cursoActions from '../../actions/cursoActions';
import * as userActions from '../../actions/userActions';
import * as paginaActions from '../../actions/paginaActions';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';


import {  useParams } from "react-router-dom";
import {  useLocation, useNavigate  } from "react-router-dom";
import withRouter from '../common/withRouter';


import { Segment} from 'semantic-ui-react';
import {genericFormattedForDropdown} from '../../selectors/selectors';
import moment from 'moment';
import {usuarioActual, getMargenes} from '../../util';
import $ from 'jquery';


class ManageCursoOpinionForm extends React.Component {

    constructor(props, context){
		super(props, context);
		this.state={
            errors:{},
            permisos:{},
			cursoopinion:{
                calificacion:0
                    }
		};
		
	}
    
    
    componentDidMount(){
        /*
        let pageInfo={
            page:'CursoOpinion',
            idioma:this.props.idioma 
        };
        this.props.paginaActions.getInfo(pageInfo, this.props.user).then( pageInfoResponse=>{
           this.setState({"permisos":pageInfoResponse.permisos,
                         "strings":pageInfoResponse.strings});
        }).catch(error=>{
          toastr.error(error);
        }); 
        
        */
        //this.props.showSidebarIzquierdaActions.sidebarIzquierda(true); 
        let id=this.props.id;
        
        usuarioActual(this, "CursoOpinion",true).then( (usuario)=>{
            
            this.props.cursoActions.getCursoCombo(usuario).then(()=>{
            }) 
            .catch(error=>{ 
              toastr.error(error); 
            }); 
            
            
            if(id && id>0 ){
                
                
                this.props.cursoopinionActions.getCursoOpinion(id, usuario).then( cursoopinion=>{
                    this.setState({"cursoopinion":cursoopinion});
                })
                .catch(error=>{
                  toastr.error(error);
                });

            }
            
         })
        .catch(error=>{
          toastr.error(error);
        });     
     
     
    }
    

    handleChange=(event, data)=> {

     
        
        let cursoopinion = this.state.cursoopinion;
        let field= data.name;		
        let value;
    
        if(data.type == 'radio'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
        
        if(data.toggle){
            if(data.checked){
                value = 1;
            }else{
                 value = 2
            }
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		cursoopinion[field[0]]= value;
		else{
             if(!cursoopinion[field[0]]){
                    cursoopinion[field[0]]={}
                }
			cursoopinion[field[0]][field[1]]= value;
		}
        
		
        this.setState({"cursoopinion": cursoopinion});
    }
    
    
    FormIsValid(){
        let formIsValid=true;
        let falla="";
        let errors={};
            
        let cursoopinion=this.state.cursoopinion;
              
        if(!validations.requerido(cursoopinion.idCurso)){
            errors.cursoId=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(cursoopinion.idPais)){
            errors.paisId=true;
            formIsValid=false;
        }
       
        
       
        if(!validations.requerido(cursoopinion.descripcion)){
            errors.descripcion=true;
            formIsValid=false;
        }
       
        
        
        this.setState({
            "errors":errors
        });
        
        if(!formIsValid){
			toastr.error("Debes capturar la información requerida.");
        }
    
        return formIsValid;
    }

    
    onChangeRate=(event, data)=>{
        
        let cursoopinion = this.state.cursoopinion;
        cursoopinion.calificacion = data.rating;
        this.setState({"cursoopinion": cursoopinion});

    }


    onSave=(event)=>{
        event.preventDefault();
        if(!this.FormIsValid()){
            return ;
        }
    
        
        this.props.cursoopinionActions.save(this.state.cursoopinion, this.props.user).then(() => {
            toastr.success("Registro guardado!!!.");
            this.props.navigate(-1);
        });
        
    }

       
    render() {	
          
         let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		 		return (
              <Segment  style={margenes}>
                <CursoOpinionForm 
                    strings={this.props.strings}
                    id={this.props.id}
                    onChange={this.handleChange}
                    errors={this.state.errors}
                    datos={this.state.cursoopinion}
                    onSave={this.onSave}      
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    color={this.props.color}
                    form={this.props.form}
                    permisos={this.state.permisos}
                    cursoCombo={genericFormattedForDropdown(this.props.cursoCombo)}
                    onChangeRate={this.onChangeRate}
                />

            </Segment> 
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
    
    return {        
            ajaxCallInProgress:state.ajaxCallInProgress,
            
            showSidebarIzquierda: state.showSidebarIzquierda,
            sidebarIzquierda: state.sidebarIzquierda, 
            color:state.color,
            user:state.user, 
            idioma:state.idioma,
            form:state.form,
            cursoCombo:state.cursoCombo,
            strings:state.strings
    }

}

function mapDispatchToProps(dispatch){

	return { 
            userActions:bindActionCreators(userActions, dispatch),
            showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
            paginaActions: bindActionCreators(paginaActions, dispatch),
            cursoopinionActions: bindActionCreators(cursoopinionActions, dispatch),
            cursoActions: bindActionCreators(cursoActions, dispatch)
	};
}


export default connect (mapStateToProps, mapDispatchToProps)(withRouter(ManageCursoOpinionForm));